<template>
  <EchartsLayout :option="option"></EchartsLayout>
</template>

<script>
import EchartsLayout from "@/components/common/EchartsLayout.vue";

export default {
  components: {
    EchartsLayout,
  },
  data() {
    return {
      option: null,
    };
  },
  methods: {
    get_component_data() {},
  },
  mounted() {
    this.option = {
      grid: { containLabel: true, right: 0, bottom: 0, top: 250, left: 0 },
      series: [
        { type: "line", ecode: { x: "月份", y: "长者自付" }, name: "长者自付" },
        { type: "line", ecode: { x: "月份", y: "家属代缴" }, name: "家属代缴" },
        { type: "line", ecode: { x: "月份", y: "自费合计" }, name: "自费合计" },
      ],
      title: {
        text: "补贴长者人数 单位：人",
        textStyle: {
          fontWeight: 700,
          fontSize: 54,
        },
        top: 100,
      },
      tooltip: { textStyle: { fontSize: 30 } },
      xAxis: {
        type: "category",
        axisLabel: {
          textStyle: {
            fontWeight: 700,
            fontSize: 54,
          },
        },
      },
      yAxis: {
        axisLabel: {
          textStyle: {
            fontWeight: 700,
            fontSize: 54,
          },
        },
      },
      legend: {
        show: true,
        height: "40%",
        width: "100%",
        itemWidth: 50,
        itemHeight: 50,
        textStyle: {
          fontWeight: 700,
          fontSize: 54,
        },
      },
      dataset: { source: [] },
    };
  },
};
</script>

<style lang="less" scoped></style>
